import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
    icon: {
        fill: '#00b600',
    },
    listIcon: { minWidth: 40 },
    nested: {
        paddingLeft: theme.spacing(4),
        color: theme.palette.text.primary,
    },
    warning: {
        backgroundColor: theme.library.requiredColor,
    },
}));
